import React, { useRef, useEffect, useState } from "react";

export const DeviceFrame = ({ mode, children }) => {
  const isMobile = mode === 'mobile';
  const width = isMobile ? 370 : 1200;
  /* const height = isMobile ? 800 : 780; */
  const zoom = isMobile ? 0.90 : 0.75;

  const scaledWidth = width / zoom;

  //manejamos el alto del contenido para que el frame se ajuste a la altura
  const scaledRef = useRef(null);
  const [contentHeight, setContentHeight] = useState();

  useEffect(() => {
    if (scaledRef.current) {
      setContentHeight(scaledRef.current.offsetHeight * zoom);
    }
  }, [children, zoom]);

  return (
    <div
      style={{
        width,
        height: contentHeight,
        border: '1px solid #ccc',
        borderRadius: 4,
        margin: '12px auto',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        background: '#fff',
        position: 'relative',
        overflow: 'visible',
        padding: 0,
        display: 'block',
        transition: 'height 0.2s',
      }}
    >
      <div
        ref={scaledRef}
        style={{
          width: scaledWidth,
          transform: `scale(${zoom})`,
          transformOrigin: 'top left',
          display: 'block',
        }}
      >
        {children}
      </div>
    </div>
  );
};
